// MindMate frontend - moodThemes.js
const moodThemes = {
  happy: {
    bg: '#FFFDE7',
    primary: '#FFD54F',
    accent: '#FFA000',
    visual: 'confetti',
  },
  calm: {
    bg: '#E0F7FA',
    primary: '#4DD0E1',
    accent: '#00838F',
    visual: 'waves',
  },
  sad: {
    bg: '#ECEFF1',
    primary: '#90CAF9',
    accent: '#1565C0',
    visual: 'gentleRain',
  },
  angry: {
    bg: '#FFEBEE',
    primary: '#EF5350',
    accent: '#C62828',
    visual: 'gentleRain',
  },
  anxious: {
    bg: '#FFFDE7',
    primary: '#FFF176',
    accent: '#F57F17',
    visual: 'breathingOrb',
  },
  neutral: {
    bg: '#FAFAFA',
    primary: '#BDBDBD',
    accent: '#757575',
    visual: '',
  },
};

export default moodThemes;
